"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRestAreaSchema = exports.CreateUserRestAreaRequestSchema = void 0;
const zod_1 = require("zod");
const rest_area_1 = require("./rest-area");
// Schema-first: types are `z.infer`-derived below, not hand-written interfaces
// checked against the schema (see driver-preferences.ts for the same pattern).
exports.CreateUserRestAreaRequestSchema = zod_1.z.object({
    category: rest_area_1.SiteCategorySchema,
    title: zod_1.z.string().min(1).max(500),
    lat: zod_1.z.number().min(-90).max(90),
    lon: zod_1.z.number().min(-180).max(180),
    /** Resolved display address (from GPS reverse-geocode, autocomplete, or manual pin), not structured. */
    address: zod_1.z.string().min(1),
    numberOfSpaces: zod_1.z.number().int().positive().optional(),
    features: rest_area_1.SiteFeaturesSchema,
    additionalPricingInfo: zod_1.z.string().max(200).optional(),
    description: zod_1.z.string().max(1000).optional(),
});
exports.UserRestAreaSchema = exports.CreateUserRestAreaRequestSchema.extend({
    id: zod_1.z.string(),
    userId: zod_1.z.string(),
    createdAt: zod_1.z.string(),
});
//# sourceMappingURL=user-rest-area.js.map